import { create } from "zustand";
import { persist } from "zustand/middleware";

interface ZoomState {
  zoomLevel: number;
  setZoomLevel: (newZoomLevel: number) => void;
  resetZoomLevel: () => void;
  zoomIn: () => void;
  zoomOut: () => void;
}

const INITIAL_ZOOM_LEVEL = 1;
const SCROLL_ZOOM_LEVEL_MULTIPLIER = 0.05;

export const useZoomStore = create<ZoomState>()(
  persist(
    (set, get) => ({
      zoomLevel: INITIAL_ZOOM_LEVEL,
      setZoomLevel: (newZoomLevel: number) => set({ zoomLevel: newZoomLevel }),
      resetZoomLevel: () => set({ zoomLevel: INITIAL_ZOOM_LEVEL }),
      zoomIn: () => set({ zoomLevel: get().zoomLevel * (1 + SCROLL_ZOOM_LEVEL_MULTIPLIER) }),
      zoomOut: () => set({ zoomLevel: get().zoomLevel * (1 - SCROLL_ZOOM_LEVEL_MULTIPLIER) }),
    }),
    {
      name: "sbdZoom",
    },
  ),
);
